module.exports = __webpack_public_path__ + "img/14.8.TSS.88e4a03a.png";